
/**
 *
 * @type {import("@reactour/tour").StepType}
 */
export const TourSteps = [
  {
    selector: ".dashboard-unit",
    content: "This shows how many units remain on your account.",
    position: "bottom",
  },
  {
    selector: ".dashboard-stats",
    content:
      "Details on actions made in your account are provided in this area",
  },
  {
    selector: ".dashboard-analytics",
    content:
      "shows the success and failure rate following a request to a prediction API.",
  },
  {
    selector: ".dashboard-api-call",
    content: "Display all the recent APIs called on the platform.",
  },
  {
    selector: ".sidebar-project",
    content:
      "Let's start with your initial project. The bulk of your models will be built in the project.",
  },
  {
    selector: ".project-toggle",
    content: "Switch between projects and competitions.",
  },
  {
    selector: ".project-create",
    content:
      "Before we can build your first models, we need to create your first project and to start, click the `Create Project` button",
    stepInteraction: false,
  },
  {
    selector: ".project-details",
    content:
      "Describes present projects; provides information about when each was established, as well as actions that can be taken, like selling, deleting, and making a project public or private. The Autogon Marketplace is a place where you may sell your project.",
  },
  {
    selector: ".project-analytics",
    content:
      "Highlights project activity that was successful and unsuccessful.",
  },
  {
    selector: ".project-actions",
    content:
      "Here, you can build models with different tools at your dispose but let's launch the studio to build your first model.",
  },
  {
    selector: ".studio-function",
    content:
      "On this tab, you get access to every function you'll need to leverage data engineering and AI blocks in new and inventive ways.",
  },
  {
    selector: ".studio-variable",
    content:
      "Your defined variables and how you've changed them throughout the project are shown on this tab as you create them on Studio.",
  },
  {
    selector: ".studio-dataset",
    content:
      "View the datasets that are accessible through your account and quickly copy their URLs.",
  },
  {
    selector: ".studio-model-and-weight",
    content:
      "Utilize this tab to track the weights and AI models you've built.",
  },
  {
    selector: ".studio-log",
    content:
      "If a block action encounters a problem, it will appear on this tab.",
  },
  {
    selector: ".studio-switcher",
    content:
      "To use your models in production mode. We have developed a pipeline window to assist you with preprocessing and transforming any data being fed into your model in parallel with the preprocessing and transforming you did to create the model.",
  },
  {
    selector: ".studio-function-list",
    content:
      "Function blocks are draggable and droppable on the canvas.  Please be aware that the 'data input' block initiates the lifecycle of a model as the initial block.",
  },
  {
    selector: ".studio-reset",
    content: "Set your project's work flow to its initial or default state.",
  },
  {
    selector: ".studio-run-block",
    content:
      "Choose a block, and hit this button and the program will run it sequentially until it reaches the last block.",
  },
  {
    selector: ".studio-zoom",
    content: "Control the canvas's zoom level to suit your preferences.",
  },
  {
    selector: ".studio-lock",
    content:
      "All of the blocks on the canvas would be locked to prevent movement.",
  },
  {
    selector: ".studio-home",
    content: "Go back to project detail",
  },
  {
    selector: ".go-to-competitions",
    content:
      "Check out competitions and other events organized by the community.",
    stepInteraction: false,
  },
  {
    selector: ".sidebar-datasets",
    content:
      "Create, view, visualize, and manage the datasets that are accessible through your account,",
  },
  {
    selector: ".dataset-create",
    content:
      "Click here to create your dataset by either an upload of your files or pasting the URLs to your dataset.",
  },
  {
    selector: ".sidebar-predikt",
    content:
      "Get predictions quickly using the models you've previously built and datasets accessed through URLs or from your account.",
  },
  {
    selector: ".sidebar-shop",
    content:
      "The Autogon Marketplace is a place where you can buy various projects that meet your needs and quickly access the models included in the project.",
  },
  {
    selector: ".shop-manage",
    content:
      "Manage all the projects you've posted on the marketplace, keep track of which ones have sold, and either add money to your marketplace wallet or take money out of your profits.",
  },
  {
    selector: ".sidebar-qore",
    content: "Leverage pre-built model to enhance your productivity.",
  },
  {
    selector: ".sidebar-chatbot",
    content:
      "Train models to get instant customer facing interactive AI chatbot.",
  },
  {
    selector: ".chatbot-create",
    content:
      "Build and train your first chatbot, we need to create your first chatbot and train before usage, click the `Create Chatbot` button",
  },
  {
    selector: ".chatbot-snippet",
    content: "The chatbot script tags are available for copying and pasting onto your website.",
  },
  {
    selector: ".chatbot-demo",
    content: "Engage in conversation with the chatbot you trained using the model.",
  },
  {
    selector: ".chatbot-edit-delete",
    content: "Here, you may modify and erase your chatbot and add or remove documents to help it learn what you need.",
  },
  {
    selector: ".billing",
    content: "Get better control over your account's expenses.",
  },
  {
    selector: ".billing-plan",
    content: "Indicates the account current subscription plan.",
  },
  {
    selector: ".billing-account-summary",
    content: "Provides further explanation on the account subscription",
  },
  {
    selector: ".billing-activities",
    content: "List all recent subscription under the account.",
  },
  {
    selector: ".billing-summary",
    content: "Provides further explanation on the subscription summary.",
  },
  {
    selector: ".billing-change",
    content: "To view all of the available subscriptions, click here.",
  },
  {
    selector: ".audit",
    content: "View all actions taken under your account over a certain period.",
  },
  {
    selector: ".audit-api",
    content: "View all API calls made via your account over an entire period.",
  },
  {
    selector: ".audit-event",
    content:
      "View all of the activities that occurred in your account over a certain time period.",
  },
  {
    selector: ".sidebar-settings",
    content:
      "Update your profile, generate API keys and manage models under your account.",
  },
  {
    selector: ".setting-apiKey",
    content: "Generate your API keys here for your API calls.",
  },
  {
    selector: ".setting-team",
    content: "Request your group to work together on various projects.",
  },
  {
    selector: ".documentation",
    content:
      "View all the documentation on all our data engineering and AI blocks, with further useful information.",
  },

  {
    selector: ".labelcraft-image",
    content: "To access the panel and examine all of your image datasets, click this button.",
  },
  {
    selector: ".labelcraft-quick-page",
    content: "To quickly build a page using any selected image, click this button.",
  },
  {
    selector: ".labelcraft-pages",
    content: "To view all generated pages, click this button.",
  },
  {
    selector: ".labelcraft-canvas",
    content: "This is where you annotate the images in your collection in every way that is possible.",
  },
  {
    selector: ".labelcraft-toolbar",
    content: "With the help of these tools, you may conduct annotations with ease. The tools include the hand tool, bounding box, zoom, delete, and label.",
  },
  {
    selector: ".labelcraft-stats-view",
    content: "This panel provides you with project-wide information.",
  },
  {
    selector: ".labelcraft-label-tag",
    content: "You get to see your own labels or tags in this panel.",
  },
];
